import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { useSFConnectionState } from '@contexts/sf-connection-context';

import {
  SalesforceConnection,
  SalesforceLoginMethod,
} from '@modules/salesforce/models';
import { ConnectionSchema } from '@modules/salesforce/shared/data/connection-schema';
import { getConnectionEnv } from '@modules/salesforce/utils/utils';

const useViewConnectionForm = () => {
  const { selectedConnection } = useSFConnectionState();

  const getDefaultValues = (connection: SalesforceConnection) => {
    const defaultValues = {
      ...connection,
      name: connection?.name,
      salesforceConnectionEdition: getConnectionEnv(connection),
      loginMethod: connection?.loginMethod ?? SalesforceLoginMethod.OAUTH,
      isAdmin: connection?.isAdmin ?? false,
      username: connection?.username,
      password: connection?.password,
      securityToken: connection?.securityToken,
      clientId: connection?.clientId,
      clientSecret: connection?.clientSecret,
      callbackUrl: connection?.callbackUrl,
      accessToken: connection?.accessToken,
      refreshToken: connection?.refreshToken,
    };

    return defaultValues;
  };

  const { watch, getValues, reset, handleSubmit } = useForm({
    resolver: yupResolver(ConnectionSchema),
    defaultValues: getDefaultValues(selectedConnection),
  });

  useEffect(() => {
    reset({
      ...getDefaultValues(selectedConnection),
    });
  }, [selectedConnection, reset]);

  return {
    values: getValues(),
    watch,
    handleSubmit,
  };
};

export { useViewConnectionForm };
